// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.styles_panelButton__9BrAO {
  justify-content: center; }
`, "",{"version":3,"sources":["webpack://./src/modules/cycles/components/AddCycleActivityButton/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,uBAAuB,EAAA","sourcesContent":["button.panelButton {\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelButton": `styles_panelButton__9BrAO`
};
export default ___CSS_LOADER_EXPORT___;
